<div class="content">
  <div class="login main-login">
    <div class="form">
      <div class="login-logo-odm">
        <img src="{{logoPath}}">
      </div>
      <form [formGroup]="form" (ngSubmit)="login()" novalidate>
        <div class="login-content">
          <h3 translate>Sign in to PowerMaster</h3>
          <div class="form-group">
            <label for="" class="col-form-label" translate>Username</label>
            <div>
              <input type="text" pInputText id="username" class="pInputText" formControlName="username" required>
            </div>
          </div>
          <div class="form-group">
            <label for="" class="col-form-label" translate>Password</label>
            <div class="inputpassword">
              <!-- <input type="password" pPassword id="password" class="pInputText" formControlName="password" required> -->
              <input type="{{inputType}}" pPassword id="password" class="pInputText" formControlName="password" required (ngModelChange)="passwordChange(password.value)">
              <p-toggleButton class="passwordIcon" onIcon="pi pi-eye" offIcon="pi pi-eye-slash" onLabel="pi-eye" offLabel="pi-eye" (onChange)="handleChange($event)" *ngIf="showPasswordIcon"></p-toggleButton>
            </div>
          </div>
          <!-- <p-message severity="error" text="Login Fail."></p-message> -->
          <div class="link">
            <a href="/resend-activation-mail" class="resend">{{'Resend Activation Mail' | translate}}</a>
            <a href="/forget-password" class="password">{{'Forget password ?' | translate}}</a>
          </div>

          <button type="submit" pButton label="{{'LOG IN' | translate}}" class="login-btn" [disabled]="isLogging"></button>
          <div class="sign">
            {{"Don't have an account?" | translate}}
            <a href="/sign-up" class=""> {{'Sign Up' | translate}}</a>
          </div>

          <p-message severity="error" text="Login Fail." *ngIf="loginFail"></p-message>
        </div>
      </form>
    </div>

    <div class="system-version"><small>v</small>{{WebVersion}}</div>
  </div>
</div>
